import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  public readonly showRightSidebar = signal(false);

  public readonly showMobileLeftSidebar = signal(false);

  constructor() { }
}
